import { Spacer, VDBText } from "@components/atoms";
import { SpaceType } from "@components/atoms/Spacer/types";
import { VDBIcons } from "@utils/VDBIcons";
import { Platform } from "react-native";
import styled from "styled-components/native";
import useScreenOptionsHooks from "../../hooks/useScreenOptionsHooks";
import { Image as RNImage } from "react-native";
import { Image as ExpoImage } from "expo-image";
import VDBIcon, { IconsVariant } from "@components/icons/VDBIcon";
import { useAIChatBotConfig } from "@redux/slices/globalSlice";

const AiChatHeader = ({
  handleClose,
}: {
  handleClearChat: () => void;
  handleClose: () => void;
}) => {
  const { typography, theme, t } = useScreenOptionsHooks();
  const ImageComponent = Platform.OS === "web" ? RNImage : ExpoImage;
  const aiChatBotConfig = useAIChatBotConfig();

  return (
    <Header>
      <HeaderSide>
        <ImageTitleContainer>
          <ImageComponent
            source={{
              uri:
                aiChatBotConfig?.icon?.type === "url"
                  ? aiChatBotConfig?.icon?.data
                  : "http://cdn.vdbapp.com/ai/chat-widget/assets/img/vdb.svg",
            }}
            resizeMode="contain"
            style={{ width: 24, height: 24 }}
          />
          <Spacer size={SpaceType.Basic} />
          <VDBText type={typography["H3-M"]} color={theme["core-05"]}>
            {t("chatbot.title.text", "VDB AI Search")}
          </VDBText>
        </ImageTitleContainer>
        <Spacer size={SpaceType.ExtraSmall} />
        <VDBText
          type={typography["Body-R"]}
          color={theme["core-06"]}
          style={{ fontStyle: "italic" }}
        >
          {t("chatbot.beta.text", "Beta")}
        </VDBText>
      </HeaderSide>
      <HeaderCenter />
      <HeaderSideRight>
        <MinimizeButton onPress={handleClose}>
          <VDBText type={typography["Body-R"]} color={theme["core-06"]}>
            {t("chatbot.minimize.text", "Minimize")}
          </VDBText>
          <Spacer size={SpaceType.ExtraSmall} />
          <VDBIcon
            name={VDBIcons.MINIMIZE}
            size={24}
            color={theme["core-04"]}
            variant={IconsVariant.VDBCustom}
          />
        </MinimizeButton>
      </HeaderSideRight>
    </Header>
  );
};

const Header = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background-color: ${({ theme }: { theme: any }) => theme["core-01"]};
  padding: 16px;
  border-bottom-width: 1px;
  border-bottom-color: ${({ theme }: { theme: any }) => theme["over-04"]};
`;

const HeaderSide = styled.View`
  flex-direction: row;
`;

const HeaderSideRight = styled.View`
  align-items: center;
  flex-direction: row;
`;

const MinimizeButton = styled.TouchableOpacity`
  flex-direction: row;
  align-items: center;
`;

const ImageTitleContainer = styled.View`
  flex-direction: row;
  align-items: center;
`;

const HeaderCenter = styled.View`
  position: absolute;
  left: 0;
  right: 0;
  align-items: center;
  pointer-events: none;
`;

export default AiChatHeader;
